import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/_components/layout/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainContainer"] */ "/opt/build/repo/app/_components/layout/Main/style.ts");
;
import(/* webpackMode: "eager", webpackExports: ["Banners"] */ "/opt/build/repo/app/_components/layout/navigation/banners/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/site/Footer/index.tsx");
